import React from "react";

const Url = () => {
    const url = process.env.REACT_APP_BASE_URL || "https://behinlab.com"
    return url;
};

export default Url;